import React from "react";
import { Navigate } from "react-router-dom";

//Dashboard

import DashboardEcommerce from "../pages/DashboardEcommerce";

//AuthenticationInner pages
import BasicSignIn from "../pages/AuthenticationInner/Login/BasicSignIn";
import CoverSignIn from "../pages/AuthenticationInner/Login/CoverSignIn";
import BasicSignUp from "../pages/AuthenticationInner/Register/BasicSignUp";
import CoverSignUp from "../pages/AuthenticationInner/Register/CoverSignUp";
import BasicPasswReset from "../pages/AuthenticationInner/PasswordReset/BasicPasswReset";
//pages

import CoverPasswReset from "../pages/AuthenticationInner/PasswordReset/CoverPasswReset";
import BasicLockScreen from "../pages/AuthenticationInner/LockScreen/BasicLockScr";
import CoverLockScreen from "../pages/AuthenticationInner/LockScreen/CoverLockScr";
import BasicLogout from "../pages/AuthenticationInner/Logout/BasicLogout";
import CoverLogout from "../pages/AuthenticationInner/Logout/CoverLogout";
import BasicSuccessMsg from "../pages/AuthenticationInner/SuccessMessage/BasicSuccessMsg";
import CoverSuccessMsg from "../pages/AuthenticationInner/SuccessMessage/CoverSuccessMsg";
import BasicTwosVerify from "../pages/AuthenticationInner/TwoStepVerification/BasicTwosVerify";
import CoverTwosVerify from "../pages/AuthenticationInner/TwoStepVerification/CoverTwosVerify";
import Basic404 from "../pages/AuthenticationInner/Errors/Basic404";
import Cover404 from "../pages/AuthenticationInner/Errors/Cover404";
import Alt404 from "../pages/AuthenticationInner/Errors/Alt404";
import Error500 from "../pages/AuthenticationInner/Errors/Error500";

import BasicPasswCreate from "../pages/AuthenticationInner/PasswordCreate/BasicPasswCreate";
import CoverPasswCreate from "../pages/AuthenticationInner/PasswordCreate/CoverPasswCreate";
import Offlinepage from "../pages/AuthenticationInner/Errors/Offlinepage";

//login
import Login from "../pages/Authentication/Login";
import VerifyPhone from "../pages/Authentication/VerifyPhone";
import ForgetPasswordPage from "../pages/Authentication/ForgetPassword";
import Logout from "../pages/Authentication/Logout";
import Register from "../pages/Authentication/Register";
import VerifyCode from "../pages/Authentication/VerifyCode";
import SetPassword from "../pages/Authentication/SetPassword";
import IncludeMTF from "../pages/Holdings/IncludeMTF";
import WithoutMTF from "../pages/Holdings/WithoutMTF";
import OnlyMTF from "../pages/Holdings/OnlyMTF";
import FinancialLedger from "../pages/Ledgers/FinancialLedger";
import LongShortPL from "../pages/Ledgers/CapitalGainReport";
import Capital from "../pages/NetPositions/Capital";
import FnO from "../pages/NetPositions/FnO";
import CapitalTrade from "../pages/TradeConfirmation/CapitalTrade";
import FnOTrade from "../pages/TradeConfirmation/FnOTrade";
import CommodityTrade from "../pages/TradeConfirmation/CommodityTrade";
import EquityPortfolio from "../pages/Portfolio/EquityPortfolio";
import FnOPortfolio from "../pages/Portfolio/FnOPortfolio";
import FnOPosition from "../pages/OpenPositions/FnOPosition";
import CommodityPosition from "../pages/OpenPositions/CommodityPosition";
import SimplePage from "../pages/Profile/SimplePage/SimplePage";
import Settings from "../pages/Profile/Settings/Settings";
import Support from "../pages/Support/Support";
import TransactionLedger from "../pages/Ledgers/TransactionLedger";
import ContractNote from "../pages/Contract Note/ContractNote";
import ContractNoteDownload from "../pages/Contract Note/ContractNoteDownload";
import Commodity from "../pages/NetPositions/Commodity";
import Annexure_10DB from "../pages/Annexure_10DB/Annexure_10DB";
import EditOptions from "../pages/Profile/EditProfile/EditOptions";
import EditProfile from "../pages/Profile/EditProfile/EditProfile";
import AddNominee from "../pages/Profile/EditProfile/AddNominee";
import AnnualIncome from "../pages/Profile/EditProfile/AnnualIncome";
import AddMtf from "../pages/Profile/EditProfile/AddMtf";
import AccountClosure from "../pages/Profile/EditProfile/AccountClosure";
import CapitalGainReport from "../pages/Ledgers/CapitalGainReport";
import Reports from "../pages/ReportsLogin/Reports";
import RiskDisclosure from "../pages/RiskDisclosure";

const authProtectedRoutes = [
  { path: "/dashboard", component: <DashboardEcommerce /> },
  { path: "/index", component: <DashboardEcommerce /> },

  // holdings
  { path: "/holdings/include-MTF", component: <IncludeMTF /> },
  { path: "/holdings/without-MTF", component: <WithoutMTF /> },
  { path: "/holdings/only-MTF", component: <OnlyMTF /> },

  // ledgers
  { path: "/ledgers/financial", component: <FinancialLedger /> },
  { path: "/ledgers/capital-gain-report", component: <CapitalGainReport /> },
  { path: "/ledgers/transaction", component: <TransactionLedger /> },

  // net positions
  { path: "/net-positions/capital", component: <Capital /> },
  { path: "/net-positions/F&O", component: <FnO /> },
  { path: "/net-positions/commodity", component: <Commodity /> },

  // portfolio
  { path: "/portfolio/equity", component: <EquityPortfolio /> },
  { path: "/portfolio/F&O", component: <FnOPortfolio /> },

  // trade confirmation
  { path: "/trade-confirmation/capital", component: <CapitalTrade /> },
  { path: "/trade-confirmation/F&O", component: <FnOTrade /> },
  { path: "/trade-confirmation/commodity", component: <CommodityTrade /> },

  // open positions

  // { path: "/open-position/capital", component: <CapitalTrade /> },
  { path: "/open-positions/F&O", component: <FnOPosition /> },
  { path: "/open-positions/commodity", component: <CommodityPosition /> },

  // Annexure 10DB
  { path: "/annexure", component: <Annexure_10DB /> },

  // profile
  { path: "/profile", component: <SimplePage /> },
  { path: "/profile-settings", component: <Settings /> },

  // edit profile
  { path: "/edit_option", component: <EditOptions /> },
  { path: "/edit_profile", component: <EditProfile /> },
  { path: "/add_nominee", component: <AddNominee /> },
  { path: "/add_annualIncome", component: <AnnualIncome /> },
  { path: "/add_mtf", component: <AddMtf /> },
  { path: "/account_closure", component: <AccountClosure /> },

  //contract note ContractNote
  { path: "/contract-note", component: <ContractNote /> },
  { path: "/contract-note-downloads", component: <ContractNoteDownload /> },

  // support
  { path: "/support", component: <Support /> },

  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  {
    path: "/",
    exact: true,
    component: <Navigate to="/dashboard" />,
  },
  { path: "*", component: <Navigate to="/dashboard" /> },
  
];

const publicRoutes = [
  // Authentication Page
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
  { path: "/verify-phone", component: <VerifyPhone /> },
  { path: "/verify-code", component: <VerifyCode /> },
  { path: "/set-password", component: <SetPassword /> },
  { path: "/forgot-password", component: <ForgetPasswordPage /> },
  { path: "/register", component: <Register /> },
  {path: "/", component: <Navigate to="/login" />},
  { path: "*", component: <Navigate to="/login" /> },
  // sso reports login
  { path: "/reports", component: <Reports /> },
  //sebi instructions page
  { path: "/risk-disclosures", component: <RiskDisclosure /> },
  //AuthenticationInner pages
  { path: "/auth-signin-basic", component: <BasicSignIn /> },
  { path: "/auth-signin-cover", component: <CoverSignIn /> },
  { path: "/auth-signup-basic", component: <BasicSignUp /> },
  { path: "/auth-signup-cover", component: <CoverSignUp /> },
  { path: "/auth-pass-reset-basic", component: <BasicPasswReset /> },
  { path: "/auth-pass-reset-cover", component: <CoverPasswReset /> },
  { path: "/auth-lockscreen-basic", component: <BasicLockScreen /> },
  { path: "/auth-lockscreen-cover", component: <CoverLockScreen /> },
  { path: "/auth-logout-basic", component: <BasicLogout /> },
  { path: "/auth-logout-cover", component: <CoverLogout /> },
  { path: "/auth-success-msg-basic", component: <BasicSuccessMsg /> },
  { path: "/auth-success-msg-cover", component: <CoverSuccessMsg /> },
  { path: "/auth-twostep-basic", component: <BasicTwosVerify /> },
  { path: "/auth-twostep-cover", component: <CoverTwosVerify /> },
  { path: "/auth-404-basic", component: <Basic404 /> },
  { path: "/auth-404-cover", component: <Cover404 /> },
  { path: "/auth-404-alt", component: <Alt404 /> },
  { path: "/auth-500", component: <Error500 /> },

  { path: "/auth-pass-change-basic", component: <BasicPasswCreate /> },
  { path: "/auth-pass-change-cover", component: <CoverPasswCreate /> },
  { path: "/auth-offline", component: <Offlinepage /> },
];

export { authProtectedRoutes, publicRoutes };
